/**
 * Collection-card financing badge picker (mirrors the PDP trust-strip logic).
 *
 * Each .csc-card-finance box holds a <klarna-placement> + a hidden Shop Pay
 * Installments message (<shopify-payment-terms> via {{ form | payment_terms }}).
 * Klarna is preferred ONLY when it renders an actual £ breakdown; above its
 * instalment limit Klarna shows a figure-less "Secure payment in seconds" promo,
 * so we surface the Shop Pay figure ("£X/mo at 0% APR") instead.
 */
(function () {
  if (window.__cscCardFinanceGuard) return;
  window.__cscCardFinanceGuard = true;

  function painted(el) {
    return !!el && (
      el.offsetHeight > 6 ||
      (el.shadowRoot && el.shadowRoot.childElementCount > 0) ||
      el.childElementCount > 0
    );
  }
  // True only when the widget has rendered an actual £ amount (a breakdown).
  function hasFigure(el) {
    if (!el) return false;
    var t = (el.shadowRoot ? el.shadowRoot.textContent : '') + ' ' + (el.textContent || '');
    return /£\s?\d/.test(t);
  }

  function evaluate(boxes) {
    (boxes || document.querySelectorAll('.csc-card-finance')).forEach(function (box) {
      var klarna = box.querySelector('.csc-card-finance__klarna, klarna-placement');
      var shoppay = box.querySelector('.csc-card-finance__shoppay');
      var shoppayEl = box.querySelector('shopify-payment-terms, shop-pay-installments-banner');
      var shoppayAvail = !!shoppayEl;
      var showKlarna = false, showShoppay = false;

      if (hasFigure(klarna)) {
        showKlarna = true;                      // Klarna shows a real breakdown → preferred
      } else if (painted(klarna)) {
        if (shoppayAvail) showShoppay = true;   // Klarna generic (no £) + Shop Pay has a figure
        else showKlarna = true;                 // keep the generic Klarna (better than nothing)
      } else if (shoppayAvail) {
        showShoppay = true;                     // Klarna not available; Shop Pay is
      }

      if (showKlarna) {
        if (klarna) klarna.style.display = 'block';
        if (shoppay) shoppay.style.display = 'none';
      } else if (showShoppay) {
        if (klarna) klarna.style.display = 'none';
        if (shoppay) shoppay.style.display = 'block';
      }
    });
  }

  /**
   * Klarna card fix (2026-10-12). On product and cart pages the Klarna On-Site
   * Messaging app rewrites EVERY <klarna-placement> on the page to the main
   * product's / cart's amount (its init + a body MutationObserver), so a related-
   * product card showed the PDP product's instalments. Each card placement now
   * carries its own price in data-csc-amount (snippets/card-product.liquid);
   * this guard restores it and blocks later rewrites. Main-product placements
   * (no data-csc-amount) are left to the app so they stay variant-aware.
   */
  var refreshTimer = null;
  // Ask the Klarna SDK to re-render after an amount was put back (covers a render
  // that was already in flight with the wrong amount). Debounced; harmless if the
  // SDK is not loaded yet (it renders with the current attributes when it does).
  function requestKlarnaRefresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () {
      try {
        if (window.Klarna && window.Klarna.OnsiteMessaging && typeof window.Klarna.OnsiteMessaging.refresh === 'function') {
          window.Klarna.OnsiteMessaging.refresh();
        } else {
          window.KlarnaOnsiteService = window.KlarnaOnsiteService || [];
          window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });
        }
      } catch (e) { /* no-op */ }
    }, 250);
  }
  function lockOwnAmount(el) {
    if (el.__cscAmountLocked) return;
    var own = el.getAttribute('data-csc-amount');
    if (!own) return;
    el.__cscAmountLocked = true;
    var nativeSet = el.setAttribute;
    el.setAttribute = function (name, value) {
      if (name === 'data-purchase-amount' && String(value) !== own) return;
      return nativeSet.call(el, name, value);
    };
    if (el.getAttribute('data-purchase-amount') !== own) {
      nativeSet.call(el, 'data-purchase-amount', own);
      requestKlarnaRefresh();
    }
  }
  // Main-product placement. Two Klarna loaders are installed on this store (the
  // theme app extension and a legacy script tag) and they disagree on products
  // whose first variant is not the one being sold (e.g. first size sold out): the
  // extension writes the selected variant's price, the legacy tag writes the first
  // variant's price, and they overwrite each other on every DOM change. The theme
  // pins the main placement to the variant the add-to-cart form will add. Prices
  // come from data-csc-variants (trust strip, id:price:available,…) or from the
  // storefront's own product meta (window.ShopifyAnalytics.meta.product.variants).
  function parseVariants(el) {
    var raw = el.getAttribute('data-csc-variants');
    if (!raw) return null;
    var list = raw.split(',').map(function (s) {
      var p = s.split(':');
      return { id: p[0], price: p[1], available: p[2] === '1' };
    }).filter(function (v) { return v.id && v.price; });
    return list.length ? list : null;
  }
  function metaVariants() {
    try {
      var vs = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product && window.ShopifyAnalytics.meta.product.variants;
      if (!vs || !vs.length) return null;
      return vs.map(function (v) { return { id: String(v.id), price: String(v.price), available: true }; });
    } catch (e) { return null; }
  }
  function selectedVariantId() {
    var input = document.querySelector('product-form form[action*="/cart/add"] input[name="id"]') ||
      document.querySelector('form[action*="/cart/add"]:not(.csc-pdp-trust__shoppay-form):not(.installment):not(.csc-card-finance__form) input[name="id"]');
    if (input && input.value) return String(input.value);
    try { return new URLSearchParams(window.location.search).get('variant'); } catch (e) { return null; }
  }
  function mainExpected(el) {
    var list = parseVariants(el) || metaVariants();
    if (!list) return null;
    var id = selectedVariantId();
    var v = id ? list.filter(function (x) { return x.id === id; })[0] : null;
    if (!v && !id) v = list.filter(function (x) { return x.available; })[0] || list[0];
    return v ? String(v.price) : null;
  }
  function lockMainAmount(el) {
    var expected = mainExpected(el);
    if (expected === null) return;
    if (!el.__cscAmountLocked) {
      el.__cscAmountLocked = true;
      var nativeSet = el.setAttribute;
      el.__cscNativeSet = nativeSet;
      el.setAttribute = function (name, value) {
        if (name === 'data-purchase-amount') {
          var exp = mainExpected(el);
          if (exp !== null && String(value) !== exp) return;
        }
        return nativeSet.call(el, name, value);
      };
    }
    if (el.getAttribute('data-purchase-amount') !== expected) {
      el.__cscNativeSet.call(el, 'data-purchase-amount', expected);
      requestKlarnaRefresh();
    }
  }
  function isProductPage() {
    return !!document.querySelector('product-form form[action*="/cart/add"] input[name="id"], form[action*="/cart/add"]:not(.csc-card-finance__form) input[name="id"]');
  }
  function lockAll() {
    document.querySelectorAll('.csc-card-finance klarna-placement[data-csc-amount]').forEach(lockOwnAmount);
    if (!isProductPage()) return;
    document.querySelectorAll('klarna-placement').forEach(function (el) {
      if (el.closest('.csc-card-finance')) return;
      lockMainAmount(el);
    });
  }
  var seenCards = new WeakSet();
  function checkNewCards(mutations) {
    var boxes = [];
    function collect(box) {
      if (!box.isConnected || seenCards.has(box)) return;
      seenCards.add(box);
      boxes.push(box);
    }
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches('.csc-card-finance')) collect(node);
        node.querySelectorAll('.csc-card-finance').forEach(collect);
      });
    });
    if (!boxes.length) return;
    // Facets replace the grid without a page load. Each new box gets the same
    // checks as the original cards, timed from its insertion rather than DCL.
    [1200, 3200, 5500, 8000, 12000, 20000].forEach(function (delay) {
      setTimeout(function () {
        evaluate(boxes.filter(function (box) { return box.isConnected; }));
      }, delay);
    });
    queueWaitingCards(boxes);
  }
  function watchCards() {
    lockAll();
    document.querySelectorAll('.csc-card-finance').forEach(function (box) { seenCards.add(box); });
    if (!('MutationObserver' in window) || !document.body) return;
    // Synchronous on purpose: the Klarna app rewrites amounts from its own body
    // observer, so restoring in the same mutation batch keeps the wrong value
    // from ever reaching the SDK's first render.
    new MutationObserver(function (mutations) {
      lockAll();
      checkNewCards(mutations);
    }).observe(document.body, { childList: true, subtree: true });
    // Variant pickers change the form's hidden id without a DOM mutation of their own.
    document.addEventListener('change', function () { lockAll(); setTimeout(lockAll, 600); setTimeout(lockAll, 1800); });
  }

  var waitingCards = [];
  var queuedCards = new WeakSet();
  var waitingTimer = null;
  var lateDeadline = 0;
  function checkWaitingCards() {
    waitingTimer = null;
    if (Date.now() >= lateDeadline) {
      waitingCards = [];
      return;
    }
    waitingCards = waitingCards.filter(function (card) {
      if (!card.box.isConnected || Date.now() >= card.deadline) return false;
      if (!hasFigure(card.klarna)) return true;
      evaluate([card.box]);
      return false;
    });
    if (waitingCards.length) {
      waitingTimer = setTimeout(checkWaitingCards, Math.min(1000, lateDeadline - Date.now()));
    }
  }
  function queueWaitingCards(boxes) {
    var deadline = Date.now() + 60000;
    boxes.forEach(function (box) {
      if (queuedCards.has(box)) return;
      queuedCards.add(box);
      waitingCards.push({ box: box, klarna: box.querySelector('.csc-card-finance__klarna, klarna-placement'), deadline: deadline });
    });
    lateDeadline = Math.max(lateDeadline, deadline);
    if (waitingTimer === null) checkWaitingCards();
  }
  function startLateChecks() {
    queueWaitingCards(document.querySelectorAll('.csc-card-finance'));
  }
  var visibleCheckSoon, visibleCheckLater;
  document.addEventListener('visibilitychange', function () {
    clearTimeout(visibleCheckSoon);
    clearTimeout(visibleCheckLater);
    if (document.visibilityState !== 'visible') return;
    evaluate();
    visibleCheckSoon = setTimeout(evaluate, 1500);
    visibleCheckLater = setTimeout(evaluate, 4000);
  });
  if (document.readyState === 'complete') startLateChecks();
  else window.addEventListener('load', startLateChecks, { once: true });

  // Klarna / Shop Pay hydrate asynchronously — re-check a few times.
  function schedule() { watchCards(); setTimeout(evaluate, 1200); setTimeout(evaluate, 3200); setTimeout(evaluate, 5500); setTimeout(evaluate, 8000); setTimeout(evaluate, 12000); setTimeout(evaluate, 20000); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule);
  else schedule();
})();
